"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = void 0;
const date_fns_1 = require("date-fns");
const formatDate = (el) => {
    const date = new Date(el);
    date.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (date.getTime() === today.getTime()) {
        return (0, date_fns_1.format)(new Date(el), "HH:mm");
    }
    if (date.getDay() - 1 === today.getDay() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()) {
        return `Wczoraj ${(0, date_fns_1.format)(new Date(el), "HH:mm")}`;
    }
    if (date.getFullYear() === today.getFullYear()) {
        return (0, date_fns_1.format)(new Date(el), "dd/MM HH:mm");
    }
    return (0, date_fns_1.format)(new Date(el), "dd/MM/yyyy HH:mm");
};
exports.formatDate = formatDate;
//# sourceMappingURL=date.js.map